module.exports = __webpack_public_path__ + "img/5.8bcbf4c0.png";